import styled, { createGlobalStyle } from 'styled-components';
import { Card, Select, DatePicker } from 'antd';
import { IToken } from 'store/ducks/globalTypes';

export const ModalBackdrop = styled.div`
  position: fixed;
  top: 0;
  left: 0;
  width: 100vw;
  height: 100vh;
  background: rgba(0, 0, 0, 0.5);
  z-index: 999;
`;

export const ContentWrapper = styled.div<IToken>`
  position: fixed;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  width: 90vw;
  max-width: 1200px;
  height: 80vh;
  background: ${(props) => props.token.colorBgContainer};
  border-radius: 12px;
  box-shadow: ${(props) => props.token.boxShadowSecondary};
  border: 1px solid ${(props) => props.token.colorBorder};
  padding: ${(props) => `${props.token.paddingLG}px`};
  z-index: 1000;
  overflow: auto;
`;

export const HeaderSection = styled.div<IToken & { scheme?: string }>`
  margin-bottom: 8px;
  text-align: left;
  padding: ${(props) => `${props.token.paddingSM}px 0`};
  border-bottom: 1px solid ${(props) => props.token.colorBorder};
`;

export const SubTitle = styled.p<IToken>`
  font-size: 14px;
  color: ${(props) => props.token.colorTextSecondary};
  margin: 4px 0 0 0;
`;

export const ContentSection = styled.div`
  display: flex;
  flex-direction: column;
  gap: 24px;
`;

export const SectionCard = styled(Card)<IToken & { scheme?: string }>`
  border-radius: 8px;
  box-shadow: ${(props) => props.token.boxShadowTertiary};

  .ant-card-body {
    padding: 24px;
  }

  h4 {
    color: ${(props) => props.token.colorPrimary};
    margin-bottom: 16px;
  }
`;

export const MetricsList = styled.ul`
  margin: 0;
  padding-left: 20px;

  li {
    margin-bottom: 8px;
    line-height: 1.6;
  }
`;

export const EntitySelect = styled(Select)`
  width: 100px;
  margin-right: 6px;
`;

export const StyledDatePicker = styled(DatePicker)`
  width: 120px;
  margin-right: 6px;
`;

export const ControlReportFilterBar = styled.div`
  max-width: 100%;
  margin-left: 20px;
`;

export const controlReportHeaderStyle = {
  paddingTop: '0px',
  paddingBottom: '0px',
  borderBottom: 'none',
  verticalAlign: 'middle',
  height: '56px',
  position: 'relative'
};

export const ControlReportValidityHeaderWrapper = styled.div`
  display: inline-block;
  position: relative;
  padding-right: 40px;

  &::after {
    content: '';
    position: absolute;
    right: -10px;
    top: 50%;
    transform: translateY(-50%);
    height: 20px;
    width: 1px;
    background-color: #d9d9d9;
  }
`;

export const ControlReportValiditySeparatorLine = styled.span`
  display: inline-block;
  position: absolute;
  right: -70px;
  top: 50%;
  transform: translateY(-50%);
  height: 20px;
  width: 1px;
  background-color: #d9d9d9;
`;

export const controlReportDateHeaderStyle = {
  paddingTop: '0px'
};

export const controlReportStartDateCellStyle = {
  borderRight: '1px solid #d9d9d9'
};

export const controlReportEndDateCellStyle = {
  position: 'relative'
};

export const controlReportEndDateCellWithSeparator = {
  position: 'relative',
  '&::after': {
    content: '""',
    position: 'absolute',
    right: '-1px',
    top: '50%',
    transform: 'translateY(-50%)',
    height: '20px',
    width: '1px',
    backgroundColor: '#d9d9d9'
  }
};

export const controlReportFrequencyCellStyle = {
  whiteSpace: 'nowrap' as const
};

export const ControlReportTableWrapper = styled.div`
  .ant-table-thead > tr:nth-child(2) > th {
    padding: 0;
    height: 0;
    line-height: 0;
    border: 0;
  }

  .ant-table-thead > tr:nth-child(2) > th::before {
    display: none;
    content: none;
  }

  .ant-table-thead
    > tr:first-child
    > th:has([class*='ControlReportValidityHeaderWrapper'])::after {
    content: '';
    position: absolute;
    right: 0;
    top: 50%;
    transform: translateY(-50%);
    height: 20px;
    width: 1px;
    background-color: #d9d9d9;
  }
`;

export const GlobalDatePickerStyle = createGlobalStyle<IToken>`
  .white-bg-datepicker .ant-picker-panel-container {
    background: #ffffff !important;
  }

  .white-bg-datepicker .ant-picker-panel {
    background: #ffffff !important;
  }

  .white-bg-datepicker .ant-picker-date-panel,
  .white-bg-datepicker .ant-picker-body {
    background: #ffffff !important;
  }
`;

export const HierarchyLevels = styled('div')`
  margin-left: 24px;
  display: flex;
`;

export const EmptyState = styled.div`
  padding: 24px;
  text-align: center;
  color: #8c8c8c;
  font-size: 14px;
`;
